__turbopack_context__.v({
  "button": "TripImageCarousel-module__4W-KPa__button",
  "buttons": "TripImageCarousel-module__4W-KPa__buttons",
  "caption": "TripImageCarousel-module__4W-KPa__caption",
  "carousel": "TripImageCarousel-module__4W-KPa__carousel",
  "container": "TripImageCarousel-module__4W-KPa__container",
  "image": "TripImageCarousel-module__4W-KPa__image",
  "imageWrapper": "TripImageCarousel-module__4W-KPa__imageWrapper",
  "item": "TripImageCarousel-module__4W-KPa__item",
  "scroller": "TripImageCarousel-module__4W-KPa__scroller",
});
